export default __webpack_public_path__ + "static/media/08.c42ef3d6.jpg";